const CAR = "/car";

export const GET_CAR_BRANDS = `${CAR}/getAllCarBrandsInInventory`;

export const GET_CAR_MODELS = `${CAR}/getAllCarModelsInInventoryGivenCarBrandIdList`;

export const GET_CAR_TRANSMISSIONS_AND_CCS = `${CAR}/getAllCarModelsTransmissionsAndCCs`;

export const GET_CAR_YEARS = `${CAR}/getAllCarModelsYears`;
